import React from 'react';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type { Props } from './ui/modal/index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const ConfigureFieldsModal = lazy(
	() => import(/* webpackChunkName: "async-issue-create-configure-fields" */ './index'),
	{ ssr: false },
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (props: Props) => (
	<ErrorBoundary
		id="async.jira.issue-create.configure-fields"
		packageName="jiraIssueCreateConfigureFields"
	>
		<Placeholder name="create-configure-fields-modal" fallback={<></>}>
			<ConfigureFieldsModal {...props} />
		</Placeholder>
	</ErrorBoundary>
);
